module App.Interfaces {
    export interface INavigationService {
        currentStep(): App.Interfaces.ICustomState;
        previousStep(): void;
        nextStep(): void;
        goToStep(name: string, replace?: boolean): void;
        goToOpertation(name: string): void;
        goToStepNumber(stepNo: number): void;
        goToStepIndex(index: number): void;

        getPreviousStep(state: Interfaces.ICustomState): Interfaces.ICustomState;
        getNextStep(state: Interfaces.ICustomState): Interfaces.ICustomState;

        getStepByStepName(stepName: string): Interfaces.ICustomState;

        getCurrentStepNumber(): ng.IPromise<number>;
        getStepNumber(stepToCompare: Interfaces.ICustomState): ng.IPromise<number>;
    }
}